import React, { FC, useEffect, useState, createRef } from 'react'
import styled, { css } from 'styled-components'

import { Box, IBox } from '@wirtualna-polska/n2cr-ds'

interface ExpandableProps {
  isExpanded: boolean
  defaultHeight?: number
}

interface WrapperProps extends ExpandableProps {
  innerHeight: number
}

const Expandable: FC<ExpandableProps & IBox> = ({
  isExpanded,
  defaultHeight = 0,
  children,
  ...rest
}) => {
  const [innerHeight, setInnerHeight] = useState(0)
  const ref = createRef<HTMLDivElement>()

  useEffect(() => {
    if (ref?.current) {
      setInnerHeight(ref.current.scrollHeight + 100)
    }
  }, [ref])

  return (
    <Wrapper
      ref={ref}
      innerHeight={innerHeight}
      defaultHeight={defaultHeight}
      isExpanded={isExpanded}
      {...rest}
    >
      {children}
    </Wrapper>
  )
}

const Wrapper = styled(Box)<WrapperProps>`
  ${p => css`
    z-index: 1;
    position: relative;
    animation: ${p.isExpanded ? 'expanded' : 'hidden'} 0.5s;
    animation-fill-mode: forwards;
    max-height: ${p.isExpanded ? p.innerHeight : p.defaultHeight}px;
    transition: max-height 0.5s;
    clip-path: inset(0);
    padding: 0 ${p.theme.space.xxs}px;
    margin: 0 -${p.theme.space.xxs}px;
    overflow: hidden;

    ${!p.innerHeight &&
    css`
      position: absolute;
      visibility: hidden;
      max-height: unset;
    `}

    @keyframes expanded {
      0% {
        clip-path: inset(0);
      }
      99% {
        clip-path: inset(0);
      }
      100% {
        clip-path: inset(-100vh -100vw);
      }
    }

    @keyframes hidden {
      from {
        clip-path: inset(0);
      }
      to {
        clip-path: inset(0);
      }
    }
  `}
`

export default Expandable
